// Amplify Auth configuration. Reads the Cognito user pool ID + client ID from
// build-time env vars set by `vite build`. These are the *public* IDs (not secrets) —
// safe to bake into the SPA bundle.

import { Amplify } from 'aws-amplify';

const USER_POOL_ID = import.meta.env.VITE_USER_POOL_ID;
const USER_POOL_CLIENT_ID = import.meta.env.VITE_USER_POOL_CLIENT_ID;

if (!USER_POOL_ID || !USER_POOL_CLIENT_ID) {
  console.error('Missing VITE_USER_POOL_ID or VITE_USER_POOL_CLIENT_ID at build time');
}

Amplify.configure({
  Auth: {
    Cognito: {
      userPoolId: USER_POOL_ID ?? '',
      userPoolClientId: USER_POOL_CLIENT_ID ?? '',
      signUpVerificationMethod: 'code',
      loginWith: {
        email: true,
        username: false,
      },
    },
  },
});
